window.playYoukuHandler = window.playYoukuHandler || function (videoId, youkuIframeSrc, autoplayOff, loopOff) {
  var $placeholder = $('[data-youku-video-placeholder=' + videoId + ']');
  
  var $videoWrapper = $placeholder.parents('.video-player-block');
  if (!$videoWrapper.hasClass('has-started')) {
    $videoWrapper.addClass('has-started playing youku-video');
    if ($placeholder.data('clientid') === '') {
      var $iframe = $('<iframe class="youku-video__iframe" src="' + youkuIframeSrc + '?autoplay=' + !autoplayOff + '&loop=' + !loopOff + '" allowfullscreen></iframe>');
      $iframe.attr('allow', !loopOff ? 'loop; autoplay' : 'autoplay');
      
      $placeholder.parent().append($iframe);
    }
    else {
      var player = new YKU.Player($placeholder.data('playerid'), {
        styleid: '0',
        client_id: $placeholder.data('clientid'),
        vid: $placeholder.data('videoid'),
        newPlayer: true,
        autoplay: true
      });
    }
  }
}